import { Component, input } from '@angular/core';
import { IColumn } from '@app/shared/interfaces/column.interface';
import { IFiltredDashboardResponse } from '@app/shared/interfaces/dashboard.interface';
import { TableComponent } from '@app/shared/components/table-component/table.component';
import { ExcelButtonComponent } from '@app/shared/components/excel-button/excel-button.component';
import { CardComponent } from '@app/shared/components/card/card.component';

@Component({
    selector: 'app-agent-reservation-cancel-change',
    imports: [TableComponent, ExcelButtonComponent, CardComponent],
    templateUrl: './agent-reservation-cancel-change.component.html',
    styleUrl: './agent-reservation-cancel-change.component.scss'
})
export class AgentReservationCancelChangeComponent {
    loading = input<boolean>(false);
    agentBiStatisticData = input<IFiltredDashboardResponse['agentBiStatistic']['results']>();

    cols: IColumn[] = [
        { key: 'reservationCancel', label: 'Reservation Cancel Count' },
        { key: 'agentName', label: 'Agent' },
        { key: 'voluntaryFlightCancel', label: 'Voluntary Flight Change Count' }
    ];

    exportData(): any[] {
        return (
            this.agentBiStatisticData()?.map((item) => ({
                reservationCancel: item.reservationCancel ?? '',
                agentName: item.agentName ?? '',
                voluntaryFlightCancel: item.voluntaryFlightCancel ?? ''
            })) ?? []
        );
    }
}
